import { ApplicationConfig } from '@angular/core'

import { provideEffects } from '@ngrx/effects'
import { provideStore } from '@ngrx/store'
import { provideStoreDevtools } from '@ngrx/store-devtools'

import { ENV } from '~env/environment'

import { ADMIN_EFFECTS, ADMIN_PROVIDERS, ADMIN_REDUCER } from './admin'
import {
  AGGREGATION_ANALYSIS_EFFECTS,
  AGGREGATION_ANALYSIS_PROVIDERS,
  AGGREGATION_ANALYSIS_REDUCER,
} from './aggregation-analysis'
import { COMPANY_EFFECTS, COMPANY_PROVIDERS, COMPANY_REDUCER } from './company'
import { FORECAST_LIST_EFFECTS, FORECAST_LIST_PROVIDERS, FORECAST_LIST_REDUCER } from './forecast-list'
import { PERFORMANCE_EFFECTS, PERFORMANCE_PROVIDERS, PERFORMANCE_REDUCER } from './performance'
import {
  QUARTERLY_DASHBOARD_EFFECTS,
  QUARTERLY_DASHBOARD_PROVIDERS,
  QUARTERLY_DASHBOARD_REDUCER,
} from './quarterly-dashboard'
import { ROUTER_FEATURE_EFFECTS, ROUTER_FEATURE_PROVIDERS, ROUTER_FEATURE_REDUCER } from './router'
import { SEARCH_FORECAST_EFFECTS, SEARCH_FORECAST_PROVIDERS, SEARCH_FORECAST_REDUCER } from './search-forecast'
import { UI_EFFECTS, UI_PROVIDERS, UI_REDUCER } from './ui'
import { USER_EFFECTS, USER_PROVIDERS, USER_REDUCER } from './user'

const STORE_REDUCERS = {
  ...UI_REDUCER,
  ...USER_REDUCER,
  ...ADMIN_REDUCER,
  ...COMPANY_REDUCER,
  ...PERFORMANCE_REDUCER,
  ...FORECAST_LIST_REDUCER,
  ...ROUTER_FEATURE_REDUCER,
  ...SEARCH_FORECAST_REDUCER,
  ...QUARTERLY_DASHBOARD_REDUCER,
  ...AGGREGATION_ANALYSIS_REDUCER,
}

const STORE_PROVIDERS = [
  ...UI_PROVIDERS,
  ...USER_PROVIDERS,
  ...COMPANY_PROVIDERS,
  ...ADMIN_PROVIDERS,
  ...PERFORMANCE_PROVIDERS,
  ...FORECAST_LIST_PROVIDERS,
  ...ROUTER_FEATURE_PROVIDERS,
  ...SEARCH_FORECAST_PROVIDERS,
  ...QUARTERLY_DASHBOARD_PROVIDERS,
  ...AGGREGATION_ANALYSIS_PROVIDERS,
]

const STORE_EFFECTS = [
  ...UI_EFFECTS,
  ...USER_EFFECTS,
  ...ADMIN_EFFECTS,
  ...COMPANY_EFFECTS,
  ...PERFORMANCE_EFFECTS,
  ...FORECAST_LIST_EFFECTS,
  ...ROUTER_FEATURE_EFFECTS,
  ...SEARCH_FORECAST_EFFECTS,
  ...QUARTERLY_DASHBOARD_EFFECTS,
  ...AGGREGATION_ANALYSIS_EFFECTS,
]

export const appStoreConfig: ApplicationConfig = {
  providers: [
    provideStore(STORE_REDUCERS),
    provideEffects(STORE_EFFECTS),
    ...STORE_PROVIDERS,

    // TODO: Fix loading queue
    // { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: Auth0Interceptor, multi: true },

    provideStoreDevtools({
      maxAge: 255, // Retains last 25 states
      logOnly: !ENV.allowNgrxDebug, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: false, // If set to true, the connection is established within the Angular zone
    }),
  ],
}
